import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  description: css`
    max-width: 400px;
    max-height: 300px;
    overflow: hidden;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
